import React from 'react'
import TagManager from 'react-gtm-module'

const GTMComponent = props => {
  const { dataLayer } = props
  const tagManagerArgs = {
    gtmId: 'GTM-NZNKZT4',
    dataLayer,
  }
  TagManager.initialize(tagManagerArgs)
  return <div />
}
export default GTMComponent
